import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GeneralSettingsComponent } from './general-settings/general-settings.component';
import { ChangepassowrdComponent } from './changepassowrd/changepassowrd.component';
import { UpdateOrgComponent } from './update-org/update-org.component';
import { RestartDialogComponent } from './restart-dialog/restart-dialog.component';
import { MessageBoxComponent } from '../shared/message-box/message-box.component';

const routes: Routes = [
  { path: 'settings', component: GeneralSettingsComponent },
  { path: 'settings/changepassword', component: ChangepassowrdComponent },
  { path: 'settings/changenumber', component: MessageBoxComponent },
  { path: 'settings/updateorg', component: UpdateOrgComponent },
  { path: 'settings/restart-app', component: RestartDialogComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
